import App from './components/App';
import { createRoot } from 'react-dom/client';

import React from 'react';
import ReactDOM from 'react-dom';
// import App from './App';

const container = document.getElementById('root');
const root = createRoot(container); // createRoot replaces ReactDOM.render
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

